<template>
  <div v-if="load" class="mb60">
    <Title :prev="'menu'"/>
    <div class="row justify-content-center">
      <div class="col-xl-10">
        <div class="edit edit--no-height bg-gray">
          <div class="d-flex align-items-end justify-content-between flex-column flex-lg-row">
            <h3 class="questions__title mr20">
              Вопросы для определения кресел автомобиля
            </h3>
            <router-link :to="{name: 'questions-new'}" class="btn btn--blue btn--small">Добавить вопрос</router-link>
          </div>
          <div class="questions">
            <div class="questions__item options-parent"
                 v-for="item in data"
                 @mouseleave="options = false"
                 @mouseenter="options = true"
            >
              {{item.name}}
              <span v-if="item.status === 'inactive'" class="disable">Отключён</span>
              <Options :namePage="'questions'"
                       :id="item._id"
                       class="options-wrap-questions"
                       :parentMouse="options"
                       :data="item"
                       :active="'questions/QUESTION_EDIT'"
                       @updateData="getData"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Loader v-else/>
</template>

<script>
  import Title from "../components/Title";
  import Options from "../components/Options";
  import Loader from "../components/Loader";
  import Tabs from "../components/Tabs";
  export default {
    name: "Questions",
    components: {Tabs, Loader, Options, Title},
    data() {
      return {
        data: [],
        load: false,
        options: true
      }
    },
    methods: {
      getData() {
        this.data = [];
        this.load = false;
        this.$store.dispatch('questions/QUESTIONS')
          .then(res => {
            this.data = res.body;
            this.load = true;
          });
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.getData();
      });
    }
  }
</script>

<style lang="scss">
  @import "../style/var";

  .questions {
    margin: 20px 0 15px;
    box-shadow: $shadow;
    &__btn {
      position: absolute;
      top: 15px;
      right: 15px;
      @media (max-width: 575px) {
        position: static;
        margin-left: 18px;
        margin-bottom: -5px;
        text-transform: lowercase;
        background-color: transparent;
        color: $blue;
        &:hover {
          background-color: transparent;
        }
      }
    }
    &__item {
      position: relative;
      display: flex;
      align-items: center;
      padding: 18px 50px 20px 30px;
      font-family: $segoe;
      background-color: #fff;
      border-bottom: 1px solid #ccc;
      @media (max-width: 575px) {
        flex-direction: column;
        align-items: flex-start;
        padding: 8px 38px 8px 8px !important;
      }
      &-dots {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 17px;
        margin-right: 15px;
        span {
          width: 2px;
          height: 2px;
          background-color: #C9C9C9;
        }
      }
      &.pr150 {
        .disable {
          margin-right: -85px;
        }
      }
      &:last-of-type {
        border-bottom: none;
      }
      &-checkbox {
        padding: 18px 15px;
      }
    }
    &__title {
      font-size: 24px;
      font-weight: 300;
      margin: 0;
      @media (max-width: 575px) {
        font-size: 20px;
      }
      &-img {
        margin-bottom: -2px;
        margin-left: 4px;
      }
      & + .btn {
        @media(max-width: 991px) {
          margin-top: 10px;
        }
      }
    }
  }

  .disable {
    margin-left: 10px;
    margin-bottom: -2px;
    padding: 1px 7px 5px;
    color: #fff;
    font-family: $segoe;
    font-size: 12px;
    text-transform: lowercase;
    background-color: $red;
    @media (max-width: 575px) {
      margin-left: 0;
      margin-top: 5px;
      margin-bottom: 0;
    }
  }
</style>